
function makeKeywords(str) {
  const obj = {};
  const words = str.split(' ');
  words.forEach(word => {
    obj[word] = true;
  });
  return obj;
}
const keywords = makeKeywords('ADD DEL MOD SHW QRY ACT BLK DLD UPLD RST POWEROP SYNC RBK SND PING STOP DSP');
const tests = {
  digit: /\d/,
  symbol: /[\w*+-]/,
};

// 跳到字符串结束符位置
function skipToEndStr(stream) {
  if (stream.skipTo('"')) {
    const cs = stream.current();
    const cs2 = cs.replace(/\\*$/g, '');
    const l1 = cs.length,
      l2 = cs2.length;
    stream.next();
    if ((l1 - l2) % 2 === 1) {
      skipToEndStr(stream);
    }
  } else {
    stream.skipToEnd();
  }
}

// 校验字符串
function isString(ch, stream) {
  if (ch === '"') {
    skipToEndStr(stream);
    return true;
  }
  return false;
}

// 校验数字;
function isNumber(ch, stream) {
  if (tests.digit.test(ch)) {
    stream.eat(ch);
    stream.eatWhile(tests.digit);
    if (stream.peek() === '.') {
      stream.next();
      stream.eatWhile(tests.digit);
    }
    return true;
  }
  return false;
}


const mmlMode = () => ({
  startState() {
    return {
      // 标记是否处于操作符后面
      afterOperator: false,
      codes: [],
    };
  },
  token(stream, state) {
    // console.log('------token----------');
    if (stream.eatSpace()) {
      return null;
    }
    const ch = stream.next();
    let returnType = 'variable';
    // 注释
    if (ch === '/' && stream.peek() === '/') {
      stream.skipToEnd();
      returnType = 'comment';
      state.codes.push(stream.current());
      state.codes.push('\n');
      return returnType;
    }
    if (ch === ';') {
      // 结束
      returnType = 'strong error';
      // 分隔符
    } else if (ch === ',' || ch === ':' || ch === '=') {
      returnType = 'hr';
    } else if (isString(ch, stream)) {
      returnType = 'string';
    } else if (isNumber(ch, stream)) {
      returnType = 'number';
    } else {
      if (stream.current().match(tests.symbol)) {
        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (stream.eat(tests.symbol) === undefined) {
            break;
          }
        }
      }
      // eslint-disable-next-line no-prototype-builtins
      if (keywords && keywords.propertyIsEnumerable(stream.current().toUpperCase())) {
        state.afterOperator = true;
        returnType = 'keyword';
      } else if (state.afterOperator) {
        state.afterOperator = false;
        returnType = 'strong atom';
      }
    }
    state.codes.push(stream.current());
    return returnType;
  },
  getCmdLst(editor) {
    this.format(editor);
    const cmdLst = [],
      lineCount = editor.lineCount(),
      reg = new RegExp('^//');
    for (let line = 0; line < lineCount; line++) {
      const cmd = editor.getLine(line);
      if (!reg.test(cmd) && cmd.trim().length > 0) {
        cmdLst.push(cmd);
      }
    }
    return cmdLst;
  },
  format(editor) {
    let cmd = '';
    const lineCount = editor.lineCount();
    for (let line = 0; line < lineCount; line++) {
      if (editor.getLine(line).trim().length > 0) { cmd = `${cmd + editor.getLine(line).trim()}\n`; }
    }
    editor.setValue(cmd.slice(0, cmd.length - 1));
  },
  doComment(editor) {
    const ranges = editor.listSelections(),
      reg = new RegExp('^//');
    ranges.forEach((range) => {
      const begin = Math.min(range.head.line, range.anchor.line);
      const end = Math.max(range.head.line, range.anchor.line);
      let comment = false;
      for (let line = begin; line <= end; line++) {
        const content = editor.getLine(line);
        if (!reg.test(content)) {
          comment = true;
          break;
        }
      }
      for (let line = begin; line <= end; line++) {
        let content = editor.getLine(line);
        const ch = content.length;
        if (!comment) {
          content = content.substring(2);
        } else {
          content = `//${content}`;
        }
        editor.replaceRange(content, { line, ch: 0 }, { line, ch });
      }
    });
  }
});

export default mmlMode;